import React, { useState } from "react";
import { useSelector } from "react-redux";
import { groupArrayByField, getOffset } from "../../helpers";
import useCurrentCategory from "../../assets/hooks/useCurrentCategory";
import { useEffect } from "react";
import { useRef } from "react";

export default function CategoryList() {

	const { products, featureColor1 } = useSelector(state => state.vendor);
	const [currentCategory, changeCategory] = useCurrentCategory();

	return <div className="categoryList noSelect" style={{ color: featureColor1 }}>
		<div className="panel">
			<ul>
				{Object.keys(groupArrayByField(products.filter(p => p.category), "category"))
					.sort((a, b) => {
						// Sorting categories alphabetically.
						let nameA = a.toLowerCase();
						let nameB = b.toLowerCase();
						if (nameA < nameB) {
							return -1;
						} else if (nameA > nameB) {
							return 1;
						} else return 0;
					})
					.map((category) => {
						return <li
							key={category}
							className={["link", "featureFont", category === currentCategory ? "active" : "inactive"].join(" ")}
							onClick={e => changeCategory(category === currentCategory ? null : category)}
						>
							{category}
						</li>
					})}
			</ul>
		</div>
	</div>
}

export function CategoryListHorizontal() {

	const { products } = useSelector(state => state.vendor);
	const [currentCategory, changeCategory] = useCurrentCategory();
	const [fixed, setFixed] = useState(false);
	const wrapper = useRef(null);

	useEffect(() => {
		// Create a listener on it for scroll events.
		function onScroll(e) {
			if (!wrapper.current) return;
			const { top } = getOffset(wrapper.current);
			const isFixed = document.scrollingElement.scrollTop >=
				top ? true : false;
			if (isFixed !== fixed) setFixed(isFixed);
		}
		document.addEventListener("scroll", onScroll);
		// Cleanup.
		return () => {
			document.removeEventListener("scroll", onScroll);
		}
	}, [wrapper, fixed]);

	return <div
		className={`categoryList-wrapper noSelect ${fixed ? "fixed" : "not-fixed"}`}
		ref={wrapper}
	>
		<ul className="categoryList categoryListHorizontal">
			{Object.keys(groupArrayByField(products.filter(p => p.category), "category")).map((category) => {
				return <li
					key={category}
					className={["link", "featureFont", category === currentCategory ? "active" : "inactive"].join(" ")}
					onClick={e => changeCategory(category === currentCategory ? null : category)}
				>
					{category}
				</li>
			})}
		</ul >
	</div>

}